import { Validator } from 'vee-validate';

const validator = new Validator();

export default validator;

// Writting the validations this way has a few benefits, including
// a. More flexibility since the validator instance can be used by any
//    part of the application (including vuex actions).
// b. We avoid loading the dependency until we need it.
// c. It may help on performance (not so much, but it's still one
//    dependency less to load on every component.)
// d. It's an small improvement to load time for the routes that don't need
//    the validator.

// More info at http://vee-validate.logaretm.com/api.html#validator
